// 入口網「新版型」preview 頁（豐富門面 demo・路線 B｜版面重排版）
// 掛在隱藏 route /officialweb_preview；舊版 official_web/views/home_page.js 不動。
// 版面：跑馬燈 → bento 首屏(hero 2/3 + 開館 1/3) → mosaic 花絮(深色滿版)
//       → 主+側雙欄(tab 消息 + 快速連結側欄) → 影音 → 書單展示(示意)。
// 已移除：館藏統計、位置資訊(footer 已含地圖，避免重複)。
import { useEffect, useState } from "react";
import { Row, Col } from "../../ui/ot";
import Marquee from "react-fast-marquee";
import styled from "styled-components";
import CarouselComponent from "../components/carousel_component";
import { useCRUDController } from "../../ui/classify_structure/CRUDController";
import QuickLinksV2 from "./quick_links_v2";
import CalendarWidget from "../../../components/component_layout/components/calendar_widget";
import SearchTabs from "../components/search_tabs";
import Video from "../components/Video";
import DemoActivityMosaic from "./demo_activity_mosaic";
import DemoNewsTabs from "./demo_news_tabs";
import BookListsV2 from "./book_lists_v2";
import { TICKER_ITEMS, VIDEO_BLOG_TYPE_DATA } from "./home_page_v2_demo_data";

const SectionTitle = styled.h2`
  font-size: 1.6rem;
  font-weight: 800;
  color: #1e3a8a;
  margin: 0.25rem 0 1rem;
  padding-left: 0.6rem;
  border-left: 6px solid #fa8c16;
`;

const BentoCard = styled.div`
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  padding: 1.25rem;
  height: 100%;
`;

const HomePageV2 = ({ prefixTitle }) => {
  const carouselController = useCRUDController({
    apiRoute: "/system/frontend/classify_structure_type_carousel",
  });

  useEffect(() => {
    document.title = `${prefixTitle} | 首頁（新版預覽）`;
  }, [prefixTitle]);

  const defaultCarouselData = [
    {
      frontend_component_blog_type_id: 1,
      blog_type_hidden_name: true,
      blog_type_id: 2922,
      blog_type_name: "",
      frontend_column_frontend_component_blog_type_blog_data: [
        {
          blog_type_blog_id: 1,
          blog_id: 100,
          title: "",
          content: "",
          annoucement_time: "2023-06-05T18:39:53.187227+08:00",
          extermal_link_check: 1,
          blog_type_classify_structure_type_blog_data: [
            { classify_structure_type_id: null, file_id: null, default_image: "/afatsBanner1.jpeg" },
            { classify_structure_type_id: null, file_id: null, default_image: "/afatsBanner2.jpeg" },
            { classify_structure_type_id: null, file_id: null, default_image: "/activity1.jpg" },
          ],
        },
      ],
    },
  ];

  const dataTransferBlog = (carouselArray) => {
    const imageData = carouselArray.map((c) => ({
      classify_structure_type_id: c.classify_structure_type_id,
      file_id: c.classify_structure_type_file_data?.[0]?.file_id ?? null,
    }));
    const result = defaultCarouselData;
    result[0].frontend_column_frontend_component_blog_type_blog_data[0].blog_type_classify_structure_type_blog_data =
      imageData;
    return result;
  };

  const [layoutDirection, setLayoutDirection] = useState("vertical");
  useEffect(() => {
    carouselController.getData({});
    const updateLayout = () => {
      const w = window.innerWidth;
      setLayoutDirection(w >= 768 && w < 992 ? "horizontal" : "vertical");
    };
    updateLayout();
    window.addEventListener("resize", updateLayout);
    return () => window.removeEventListener("resize", updateLayout);
  }, []);

  const calendarProps = { showEvents: true };
  const hasCarousel =
    carouselController.ResponseData && carouselController.ResponseData.length !== 0;

  return (
    <Row gutter={[16, 20]} justify={"center"} style={{ padding: "1rem" }}>
      {/* 跑馬燈快訊 */}
      <Col span={24}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            background: "linear-gradient(90deg,#1e3a8a,#2563eb)",
            borderRadius: "10px",
            color: "#fff",
            overflow: "hidden",
          }}
        >
          <span
            style={{
              flexShrink: 0,
              padding: "0.55rem 1rem",
              background: "#fa8c16",
              fontWeight: 700,
              whiteSpace: "nowrap",
            }}
          >
            最新快訊
          </span>
          <Marquee gradient={false} speed={45} pauseOnHover style={{ padding: "0.55rem 0" }}>
            {TICKER_ITEMS.map((t, i) => (
              <span key={i} style={{ margin: "0 2.5rem", fontWeight: 500 }}>
                {t}
              </span>
            ))}
          </Marquee>
        </div>
      </Col>

      {/* 首屏 bento：hero(2/3) + 開館時間(1/3) */}
      <Col span={24}>
        <Row gutter={[16, 16]} align={"stretch"}>
          <Col xxl={16} xl={16} lg={16} md={24} sm={24} xs={24}>
            <BentoCard>
              <SearchTabs propsNavigateSearchPath={"/library"} />
              <div style={{ marginTop: "1rem" }}>
                <CarouselComponent
                  blogTypeData={hasCarousel ? dataTransferBlog(carouselController.ResponseData) : defaultCarouselData}
                />
              </div>
            </BentoCard>
          </Col>
          <Col xxl={8} xl={8} lg={8} md={24} sm={24} xs={24}>
            <BentoCard style={{ padding: "0.75rem" }}>
              <CalendarWidget {...calendarProps} layoutDirection={layoutDirection} />
            </BentoCard>
          </Col>
        </Row>
      </Col>

      {/* 活動花絮 mosaic（深色滿版） */}
      <Col span={24}>
        <div
          style={{
            background: "linear-gradient(135deg,#0f172a,#1e293b)",
            borderRadius: "16px",
            padding: "1.5rem",
          }}
        >
          <SectionTitle style={{ color: "#ffffff", borderLeftColor: "#fa8c16" }}>活動花絮</SectionTitle>
          <DemoActivityMosaic />
        </div>
      </Col>

      {/* 主+側雙欄：tab 消息 + 快速連結側欄 */}
      <Col span={24}>
        <Row gutter={[16, 16]}>
          <Col xxl={16} xl={16} lg={15} md={24} sm={24} xs={24}>
            <SectionTitle>最新消息・活動快訊</SectionTitle>
            <DemoNewsTabs />
          </Col>
          <Col xxl={8} xl={8} lg={9} md={24} sm={24} xs={24}>
            <SectionTitle>快速連結</SectionTitle>
            <QuickLinksV2 />
          </Col>
        </Row>
      </Col>

      {/* 影音專區（淺色底） */}
      <Col span={24}>
        <div style={{ background: "#f1f5f9", borderRadius: "16px", padding: "0.5rem 1rem 1rem" }}>
          <Video blogTypeData={VIDEO_BLOG_TYPE_DATA} />
        </div>
      </Col>

      {/* 書單展示（原「館藏統計」位置）— preview-local 精緻版：多組書單膠囊切換＋精緻書架，串接同原本，不動共用元件 */}
      <Col span={24}>
        <SectionTitle>書單展示</SectionTitle>
        <BookListsV2 />
      </Col>
    </Row>
  );
};

export default HomePageV2;
